import {useEffect, useState} from 'react'
import Navbar from './Navbar'
import "./MainPage.css"
import { FaChevronDown,FaChalkboardTeacher, FaChevronUp, FaTimes, FaHome, FaUtensils, FaTag, FaExchangeAlt, FaCalendarAlt, FaClock, FaDatabase, FaSmile, FaGoogle, FaCreditCard, FaUser, FaCode, FaCheckCircle, FaBolt, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import nastaveniImage from '../images/nastaveni.png';





const MainPage = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  const [isOpen, setIsOpen] = useState(Array(14).fill(false));
  
  const handleOpen = (index) => {
    setIsOpen((prev) => prev.map((item, i) => (i === index ? !item : item)));
  };

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    scrollToTop()
  }, [])

  const handleRegisterFreeButtonClick = () => {
    window.gtag('event', 'click', {
      event_category: 'Button',
      event_action: 'Click',
      event_label: 'Registrace ZDARMA Tlacitko',
    });
  };
  const handleAPIButtonClick = () => {
    window.gtag('event', 'click', {
      event_category: 'Button',
      event_action: 'Click',
      event_label: 'Api dokumentace Tlacitko',
    });
  };

  const handleSlotReservationViewButtonClick = () => {
    window.gtag('event', 'click', {
      event_category: 'Button',
      event_action: 'Click',
      event_label: 'Nahled slot profilu',
    });
  };
  const handleBasicReservationViewButtonClick = () => {
    window.gtag('event', 'click', {
      event_category: 'Button',
      event_action: 'Click',
      event_label: 'Nahled Basic profilu',
    });
  };
  const handleBookingReservationViewButtonClick = () => {
    window.gtag('event', 'click', {
      event_category: 'Button',
      event_action: 'Click',
      event_label: 'Nahled Booking profilu',
    });
  };

  return (
    <div>
        <Navbar />
        <div className='main-container'>
        <div className="cover-main-container">

      <div className="cover-overlay">
        <div className="cover-content">
          <h1 className="cover-title">{process.env.REACT_APP_URL_NAME}</h1>
          <p className="cover-description">
            Hledáte spolehlivý rezervační systém nebo se chcete prezentovat a nemáte svůj web?
          </p>
          <div className="cover-button-container">
            <Link to="/business/register" onClick={handleRegisterFreeButtonClick} className="cover-button">
              Vyzkoušejte ZDARMA
            </Link>
          </div>
        </div>
      </div>
    </div>
    
        <div className='advantages-container'>
        <h1 className='advantages-title'>S NÁMI</h1>
        <h2 className='advantages-title-second'>Ušetříte čas i námahu s naším rezervačním systémem</h2>
    <div className='advantages-row'>
    <div className='advantages-column'>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(0)}><h3><FaUser /> Vlastní profil</h3>{ isOpen[0] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}</div>
      <p className={ isOpen[0] ? "open-text" : "close-text"}>
        Nastavení vlastního profilu, který bude prezentovat vaši službu.
    </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(1)}><h3>
        <FaCode /> Integrace s API</h3>{ isOpen[1] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
      </div>
      <p className={ isOpen[1] ? "open-text" : "close-text"}>
        Možnost propojení s dalšími aplikacemi a službami pomocí API.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(2)}><h3>
        <FaCheckCircle />
       Snížení chybovosti
       </h3>{ isOpen[2] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
       </div>
      <p className={ isOpen[2] ? "open-text" : "close-text"}>
        Automatizovaný proces snižuje riziko chyb.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(3)}><h3><FaBolt />
       Rychlá reakce na poptávku
       </h3>{ isOpen[3] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
       </div>
       <p className={ isOpen[3] ? "open-text" : "close-text"}>
        Systém okamžitě aktualizuje dostupnost pro zákazníky.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(4)}><h3><FaCalendarAlt />
       Sledování rezervací v reálném čase
       </h3>{ isOpen[4] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
       </div>
       <p className={ isOpen[4] ? "open-text" : "close-text"}>
        Okamžitý přehled všech aktuálních rezervací.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(5)}><h3><FaEnvelope /> Automatické emaily
      </h3>{ isOpen[5] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
      </div>
      <p className={ isOpen[5] ? "open-text" : "close-text"}>
        Automatické e-maily informují o pokroku rezervace.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(6)}><h3><FaExchangeAlt /> Výběr z více systémů</h3>{ isOpen[6] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
      </div>
      <p className={ isOpen[6] ? "open-text" : "close-text"}>

        Vyberte si z několika rezervačních systémů, které nejlépe vyhovují vašim potřebám.
      </p>
    </div>
    
</div>

<div className='divider'></div>

<div className='advantages-column'>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(7)}><h3><FaCalendarAlt /> Dostupnost</h3> { isOpen[7] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
      </div>
      <p className={ isOpen[7] ? "open-text" : "close-text"}>
        Zákazníci mohou provádět rezervace kdykoliv, bez ohledu na čas.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(8)}><h3><FaClock /> Úspora času</h3>{ isOpen[8] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
      </div>
      <p className={ isOpen[8] ? "open-text" : "close-text"}>
        Online rezervační systém šetří čas a zjednodušuje proces rezervací.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup'  onClick={() => handleOpen(9)}>
        <h3><FaDatabase /> Snadné spravování rezervací</h3>{ isOpen[9] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
        </div>
      <p className={ isOpen[9] ? "open-text" : "close-text"}>
        Všechny rezervace na jednom místě pro lepší přehlednost.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup'  onClick={() => handleOpen(10)}>
        <h3><FaSmile /> Zlepšení zákaznické zkušenosti</h3>{ isOpen[10] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
        </div>
      <p className={ isOpen[10] ? "open-text" : "close-text"}>
        Zákazníci ocení jednoduchý a přehledný proces rezervace.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(11)}>
        <h3><FaGoogle /> Integrace s Google Kalendářem</h3>{ isOpen[11] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
        </div>
      <p className={ isOpen[11] ? "open-text" : "close-text"}>
        Snadné propojení s Google kalendářem pro nastavení události.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(12)}>
        <h3><FaCreditCard /> Bezpečné platby online</h3>{ isOpen[12] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
        </div>
      <p className={ isOpen[12] ? "open-text" : "close-text"}>
        Bezpečné online platby bez rizika chyb při manuálním zpracování.
      </p>
    </div>
    <div className='advantage-item'>
      <div className='advantage-text-showup' onClick={() => handleOpen(13)}>
        <h3><FaTag />Trial Forever ZDARMA</h3>{ isOpen[13] ? <FaChevronUp className='advantage-text-showup-visible' /> : <FaChevronDown className='advantage-text-showup-visible' />}
        </div>
        <p className={isOpen[13] ? "open-text" : "close-text"}>
  Do 30 rezervací měsíčně zdarma – navždy, bez skrytých poplatků, pro každý profil. U poboček pro každý vytvořený profil.
</p>
        </div>
</div>
  </div>

    </div>
    <div className='background'>
    <div className='advantages-choice-container'>
      <h1 className='advantages-title-right'>VÍCE SYSTÉMŮ</h1>
      <h2 className='advantages-title-second-right'>Vyberte si jeden z těchto rezervačních systémů, nebo klidně všechny najednou</h2>
      <div className="all-system-container">

      <div className='one-system-container'>
      <div className="one-system">
        <FaCalendarAlt className="system-icon" />
        <h3 className="system-title">Rezervační systém pro služby a poradenství</h3>
        <p className="system-description">Kalendář s rezervačními sloty pro různé služby.</p>
       
      </div>
      <Link to="/business/public/67ce8ec8bc7def9df9747bc3" onClick={handleSlotReservationViewButtonClick}><button  className='one-system-button'>Náhled profilu</button></Link>
      </div>
      <div className='one-system-container'>
      <div className="one-system">
        <FaUtensils className="system-icon" />
        <h3 className="system-title">Rezervační systém pro restaurace a bary</h3>
        <p className="system-description">Efektivní rezervace stolů pro restaurace a bary.</p>
        
      </div>
      <Link to="/business/public/67fe0c91608a1f77084f593b" onClick={handleBasicReservationViewButtonClick}><button  className='one-system-button'>Náhled profilu</button></Link>
      </div>

      <div className='one-system-container'>
      <div className="one-system">
        <FaHome className="system-icon" />
        <h3 className="system-title">Rezervační systém pro objekty</h3>
        <p className="system-description">Jednoduchá správa rezervací objektu( Mimo hotel/penzion).</p>
        
      </div>
      <Link to="/business/public/67f7714ff3ee3a9f14550d9d" onClick={handleBookingReservationViewButtonClick}><button  className='one-system-button'>Náhled profilu</button></Link>
      </div>
      <div className='one-system-container'>
      <div className="one-system">
        <FaChalkboardTeacher className="system-icon" />
        <h3 className="system-title">Rezervační systém pro lekce</h3>
        <p className="system-description">Jednoduchá správa lekcí a kroužků.</p>
        
      </div>
      <Link to="/business/public/682590b67e59da3b46397a87" onClick={handleBookingReservationViewButtonClick}><button className='one-system-button'>Náhled profilu</button></Link>
      </div>
      </div>

    </div>

    <div className='button-center'>
    <Link to="/business/register" onClick={handleRegisterFreeButtonClick}><button className='profile-button'>Vyzkoušejte ZDARMA</button></Link>
  </div>
    </div>
    <div className='advantages-container'>
      <div className='main-profile-container'>
        
      <div className="profile-section">
      <h1 className='advantages-title'>NASTAVTE SI SVŮJ PROFIL</h1>
      <h2 className='advantages-title-second'>Mějte správu profilu plně pod kontrolou</h2>
      <p>
        <strong>Vyzkoušejte ZDARMA</strong>, platí se až ve chvíli, kdy budete chtít přejít na neomezený počet rezervací na jednom profilu.
      </p>
      <p>
        Přizpůsobte si profil podle svých potřeb. Vyberte si vhodné funkce a nastavte si rezervační systém dle svých požadavků. Přidávejte obrázky, spravujte galerii a vylepšete svou vizuální prezentaci.  
        Nastavte si pracovní dobu a upravte kontaktní údaje, aby vás zákazníci snadno našli. Zobrazte svou polohu na mapě a přizpůsobte nabídku služeb přesně tak, jak potřebujete.
      </p>

      </div>
      <div className="profile-image-section">
        <img onClick={()=> setIsOverlayOpen(true)} className="" src={nastaveniImage} alt="setting-photo" />
                    {isOverlayOpen && (
                        <div
                            className="setting-overlay active"
                            onClick={() => setIsOverlayOpen(false)} >

                            <FaTimes className="setting-overlay-close" onClick={() => setIsOverlayOpen(false)} />
        
                            <img className="" src={nastaveniImage} alt="setting-photo" />
        

                        </div>
                    )}
      </div>
      </div> 

      </div>
      <div className='background'>
        <div className='advantages-choice-container'>
          <h1 className='advantages-title-right'>CENÍK</h1>
          <h2 className='advantages-title-second-right'>Vyberte si jestli chcete platit měsíčně, nebo jednou ročně. Dokonce za vás můžeme nastavit profil</h2>
          <div className="all-pricing-container">
          <div className='one-pricing-container'>
              <h2>Trial Forever</h2>
              <p><span>✔ Vlastní profil</span>
              <span>✔<strong> 30 rezervací / měsíc</strong></span>
  <span>✔ Integrace s API</span>
  <span>✔ Integrace Iframe bez znalosti kódování</span>
  <span>✔ Rychlá reakce na poptávku</span>
  <span>✔ Sledování rezervací v reálném čase</span>
  <span>✔ Automatické emaily</span>
  <span>✔ Výběr z více systémů</span>
  <span>✔ Snadné spravování rezervací</span>
  <span>✔ Integrace s Google Kalendářem</span>
  <span></span>
  </p>
              <h2 className='price'>ZDARMA</h2>
            </div>
            <div className='one-pricing-container'>
              <h2>MĚSÍČNÍ</h2>
              <p><span>✔ Vlastní profil</span>
              <span>✔<strong> Neomezeně rezervací</strong></span>
  <span>✔ Integrace s API</span>
  <span>✔ Integrace Iframe bez znalosti kódování</span>

  <span>✔ Rychlá reakce na poptávku</span>
  <span>✔ Sledování rezervací v reálném čase</span>
  <span>✔ Automatické emaily</span>
  <span>✔ Výběr z více systémů</span>
  <span>✔ Snadné spravování rezervací</span>
  <span>✔ Integrace s Google Kalendářem</span><span></span></p>
              <h2 className='price'>{`${process.env.REACT_APP_MONTHLY_PRICE}`}  Kč</h2>
            </div>
            <div className='one-pricing-container'>
              <h2>ROČNÍ</h2>
              <p>  <span>✔ Vlastní profil</span>
              <span>✔<strong> Neomezeně rezervací</strong></span>
  <span>✔ Integrace s API</span>
  <span>✔ Integrace Iframe bez znalosti kódování</span>

  <span>✔ Rychlá reakce na poptávku</span>
  <span>✔ Sledování rezervací v reálném čase</span>
  <span>✔ Automatické emaily</span>
  <span>✔ Výběr z více systémů</span>
  <span>✔ Snadné spravování rezervací</span>
  <span>✔ Integrace s Google Kalendářem</span>
              <span></span></p>              
              <h2 className='price'>{`${process.env.REACT_APP_YEARLY_PRICE}`} Kč</h2>
            </div>
            <div className='one-pricing-container'>
              <h2>MĚSÍČNÍ - MultiProfiles</h2>
              <p><span>✔ 3 Pobočky v ceně</span>
              <span>každá další pobočka 99Kč/ měsíc</span>
              <span>✔<strong> Neomezeně rezervací</strong></span>
              <span>✔ Neomezeno profilů na jednu pobočku</span>
  <span>✔ Integrace s API</span>
  <span>✔ Integrace Iframe bez znalosti kódování</span>

  <span>✔ Rychlá reakce na poptávku</span>
  <span>✔ Sledování rezervací v reálném čase</span>
  <span>✔ Automatické emaily</span>
  <span>✔ Výběr z více systémů</span>
  <span>✔ Snadné spravování rezervací</span>
  <span>✔ Integrace s Google Kalendářem</span><strong>V režimu Forever Free limit 30 rezervací / měsíc / profil ZDARMA</strong><span></span></p>
              <h2 className='price'>{`${process.env.REACT_APP_MONTHLY_ADMIN_PRICE}`}  Kč</h2>
            </div>
          </div>
        </div>
        <div className='button-center'>
    <Link to="/business/register" onClick={handleRegisterFreeButtonClick}><button className='profile-button'>Registrace ZDARMA</button></Link>
  </div>
      </div>
      <div className='advantages-container'>
      <div>
        <h1 className='advantages-title'>PROPOJENÍ PŘES API</h1>
        <h2 className='advantages-title-second'>Integrujte rezervační formulář přes API na váš web</h2>
      </div>
          <Link onClick={handleAPIButtonClick} to="/doc"><div className='developer-button'>
            <h2>Dokumentace pro vývojáře</h2>
          </div></Link>
      </div>

      </div>
    </div>
  )
}

export default MainPage